module.exports = __webpack_public_path__ + "img/dice-2.ed3c2e0f.png";